import { HighchartsOptions } from "../../../shared/component/highcharts-common/highcharts-global-const";

export class BmAnalyticsCard {
  title: string;
  budgetValue: string;

  constructor(
    title: string,
    budgetValue: string,
  ) {
    this.title = title;
    this.budgetValue = budgetValue;
  }
}

export class BmSelectedChart {
  barChart: BmBarChartsTypes = BmBarChartsTypes.capRequired;
  pieChart: BmPieChartsTypes = BmPieChartsTypes.actual;
}

export enum BmBarChartsTypes {
  capRequired = 'capRequired',
  totalExp = 'totalExp',
  investment= 'investment',
  mgmFee = 'mgmFee',
  opExp = 'opExp',
  orgExp = 'orgExp'
}

export enum BmPieChartsTypes {
  actual = 'actual',
  budget = 'budget',
}

export class BmAnalyticsChartsOptions {
  bar: BmAnalyticsBarTypes;
  pie: BmAnalyticsChartData;
}

export class BmAnalyticsBarTypes {
  capRequired: BmAnalyticsChartData;
  totalExp: BmAnalyticsChartData;
  investment: BmAnalyticsChartData;
  mgmFee: BmAnalyticsChartData;
  opExp: BmAnalyticsChartData;
  orgExp: BmAnalyticsChartData;
}

export class BmAnalyticsChartData {
  chartId: string;
  additionalOptions: Partial<HighchartsOptions>;
}

export class BmAnalyticsBarChartsData {
  capRequired: [number, number, number][];
  totalExp: [number, number, number][];
  investment: [number, number, number][];
  mgmFee: [number, number, number][];
  opExp: [number, number, number][];
  orgExp: [number, number, number][];
}
